export const CS_BREAKPOINTS = {
  xs: 0,
  sm: 430,
  md: 744,
  lg: 1024,
  xl: 1440,
};
